module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"all":"Alle Veröffentlichungen","spotlight":"Im Rampenlicht der Medien"},"en":{"all":"All publications","spotlight":"In the media spotlight"},"it":{"all":"","spotlight":""},"lt":{"all":"Visi straipsniai ","spotlight":"Mes spaudoje"},"pl":{"all":"Wszystkie publikacje","spotlight":"Media o nas"}}')
  delete Component.options._Ctor
}
